<template>
  <div class="tc-checkbox-buttons">
    <button
      id="privacyButtonEnable"
      class="tccs-button button-disagree"
      @click.stop="toggleValue(false)"
      @keydown.space.prevent="toggleValue(false)"
      @keydown.enter="toggleValue(false)"
      role="button"
      :aria-label="$t('disableCookieAria', { label: stripHtml(ariaLabel) })"
      :aria-pressed="ariaPressedOff"
      :aria-disabled="disabled"
      :tabindex="disabled ? -1 : 0"
    >
      {{ labelOff }}
    </button>
    <button
      id="privacyButtonDisable"
      class="tccs-button button-allow"
      @click.stop="toggleValue(true)"
      @keydown.space.prevent="toggleValue(true)"
      @keydown.enter="toggleValue(true)"
      role="button"
      :aria-label="$t('enableCookieAria', { label: stripHtml(ariaLabel) })"
      :aria-pressed="ariaPressedOn"
      :aria-disabled="disabled"
      :tabindex="disabled ? -1 : 0"
    >
      {{ labelOn }}
    </button>
  </div>
</template>
<script>
import { i18nMixin } from 'shared/i18n/i18n-mixin';
import { stripHtml } from '@/common/filters/strip-html';

export default {
  mixins: [i18nMixin],
  props: {
    value: {
      type: Boolean,
    },
    i18nAriaLabel: {
      type: String,
      default: () => 'defaultButtonAriaLabel',
    },
    i18nAriaRadionOn: {
      type: String,
      default: () => 'defaultButtonAriaOnRadio',
    },
    i18nAriaRadionOff: {
      type: String,
      default: () => 'defaultButtonAriaOffRadio',
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    labelOn: {
      type: String,
      default: () => 'On',
    },
    labelOff: {
      type: String,
      default: () => 'Off',
    },
    ariaLabel: {
      type: String,
      default: () => '',
    },
  },
  computed: {
    ariaPressedOn() {
      return this.value === true ? 'true' : 'false';
    },
    ariaPressedOff() {
      return this.value === false ? 'true' : 'false';
    },
  },
  methods: {
    stripHtml,
    toggleValue(value) {
      if (this.disabled) {
        return;
      }
      if (this.value === null) {
        this.$emit('input', value);
      } else if (value === true) {
        this.$emit('input', true);
      } else {
        this.$emit('input', false);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$toggle-color: #ffffff;
$on-color: #3075e4;
$off-color: #d13d3d;
$background-color: #9c9c9c;
$label-color: #000;

.tc-checkbox-buttons {
  height: 3rem;
  display: inline-flex;
  flex-flow: row nowrap;
  flex-direction: row;
  color: white;

  .tccs-button {
    padding: 0.5rem 2rem;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out, border-color 0.3s ease-in-out, color 0.3s ease-in-out;

    &.button-disagree {
      margin-right: 1rem;

      &[aria-pressed='false'] {
        background-color: $toggle-color;
        color: $label-color;
        border: 1px solid black;
      }

      &[aria-pressed='true'] {
        background-color: $off-color;
        color: white;
        border: 1px solid $off-color;
      }

      &[aria-pressed='mixed'] {
        background-color: $toggle-color;
        color: $label-color;
        border: 1px solid black;
      }

      &[aria-disabled='true'] {
        display: none;
      }
    }

    &.button-allow {
      margin-right: 1rem;

      &[aria-pressed='false'] {
        background-color: $toggle-color;
        color: $label-color;
        border: 1px solid black;

        &[aria-disabled='true'] {
          display: none;
        }
      }

      &[aria-pressed='true'] {
        background-color: $on-color;
        color: white;
        border: 1px solid $on-color;
      }

      &[aria-pressed='mixed'] {
        background-color: $toggle-color;
        color: $label-color;
        border: 1px solid black;
      }

      &[aria-disabled='true'] {
        opacity: 0.5;
        cursor: initial;
      }
    }
  }
}
</style>
